import { render } from "./forgotpassword.vue?vue&type=template&id=4e5eb95c&scoped=true"
const script = {}

import "./forgotpassword.vue?vue&type=style&index=0&id=4e5eb95c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5eb95c"]])

export default __exports__